import { api } from '@/utils/api'
// import router from '../router'
// const info = JSON.parse(localStorage.getItem('info'))

const state = () => {
  return {
    loadingPage: true,
    company: [],
    companyDefault: null,
    currency: [],
    currencyDefault: 'THB',
    employee: [],
    employeeAll: [],
    employeeDefault: {
      bu_no: '',
      bu_name: '',
      fullname_th: '',
      employee_id: '',
      telephone: ''
    },
    cash: [],
    taxRate: [],
    catCode: [],
    documentSpacialPath: [],
    cashDefault: 'c',
    fileUploadMaxSizeKb: 0,
    fileUploadMaxSize: 0,
    overBudget: {
      message: null,
      isOver: true,
      show: false
    },
    advanceCostADV1: [],
    advanceCostADV2: [],
    advanceCostADV3: [],
    uom: [],
    docWait: {
      pv: 0,
      ca: 0,
      cl: 0,
      pr: 0,
      po: 0,
      gr: 0,
      of: 0,
      rf: 0,
      reimbursement: 0,
      procurement: 0,
      preorder: 0
    },
    optionBudget: [],
    optionBudgetSubledger: [],
    optionFilterList: {
      memo: [],
      reimburement: [],
      procurement: [],
      preorder: []
    },
    optionStatusList: {
      pv: [],
      ca: [],
      cl: [],
      pr: [],
      po: [],
      gr: [],
      of: [],
      rf: []
    },
    btnResend: {
      disabled: false,
      loading: false,
      hide: true
    },
    filters: {
      optionSelected: null,
      filterValue: null,
      companySelected: null,
      statusSelected: null,
      optionTab: null,
      page: 0
    },
    analysisCode: [],
    analysisCode1: [],
    analysisCode2: [],
    analysisCode9: [],
    analysisCode10: [],
    bcVatProd: [],
    bcWhtBus: [],
    bcWhtProd: [],
    bcElim: []
  }
}

const getters = {
  getUOMOptions(state) {
    return state.uom.map(item => {
      return {
        label: item.uom_name,
        value: item.uom_code
      }
    })
  },
  companyFind(state) {
    return id => {
      return state.company.find(item => item.comp_no == id)
    }
  },
  cashFind(state) {
    return id => {
      return state.cash.find(item => item.value == id)
    }
  },
  getCatCodeText(state) {
    return catCode => {
      if (catCode !== null) {
        const code = state.catCode.find(item => item.cat_code === catCode)
        if (code) {
          return `${code.cat_code} - ${code.cat_name}`
        } else {
          return 'ข้อมูลไม่ตรงกัน'
        }
      } else {
        return 'ไม่ระบุ'
      }
    }
  },
  getTaxRateText(state) {
    return taxRate => {
      if (taxRate) {
        const rate = state.taxRate.find(item => item.tax_code === taxRate)
        if (rate) {
          return `${rate.tax_code} - ${rate.tax_name}`
        } else {
          return 'ข้อมูลไม่ตรงกัน'
        }
      } else {
        return 'ไม่ระบุ'
      }
    }
  },
  getUOMbyOne(state) {
    return uom => {
      if (uom) {
        return state.uom.find(item => item.uom_code == uom)
      } else {
        return {
          uom_code: '',
          uom_name: ''
        }
      }
    }
  },
  getUOMbyThree(state) {
    return three => {
      return three.map(row => {
        return state.uom.find(item => item.uom_code == row.unit)
      })
    }
  },
  getResetFilterList(state) {
    return module => {
      if (state.optionFilterList[module].length > 0) {
        return state.optionFilterList[module][0].value
      } else {
        return 'doc_no'
      }
    }
  },
  getPlaceholderDefaultFilterList(state) {
    return module => {
      if (state.optionFilterList[module].length > 0) {
        return state.optionFilterList[module][0].placeholder
      } else {
        return 'เลข 6 ตัวสุดท้าย'
      }
    }
  },
  getPlaceholderFilterList(state) {
    return (id, module) => {
      const t = state.optionFilterList[module].find(item => {
        return item.value == id
      })
      if (t) {
        return t.placeholder
      } else {
        return ''
      }
    }
  },
  getCompanyOptions(state) {
    return state.company.map(item => {
      return {
        label: item.comp_name_th,
        value: item.comp_no
      }
    })
  },
  getAnalysisCodeText(state) {
    return code => {
      if (code != '' && code.toUpperCase() != 'Z') {
        const tmp = state.analysisCode.find(item => item.code === code)
        if (tmp) {
          return `${tmp.code} - ${tmp.name}`
        } else {
          return 'ข้อมูลไม่ตรงกัน'
        }
      } else {
        return 'ไม่ระบุ'
      }
    }
  },
  getBcVatProd(state) {
    return code => {
      const rs = state.bcVatProd.find(item => item.vat_code === code)
      return rs ? `${rs.vat_code} - ${rs.vat_description}` : 'ไม่ระบุ'
    }
  },
  getBcWhtBus(state) {
    return code => {
      const rs = state.bcWhtBus.find(item => item.code === code)
      return rs ? `${rs.code} - ${rs.description}` : 'ไม่ระบุ'
    }
  },
  getBcWhtProd(state) {
    return code => {
      const rs = state.bcWhtProd.find(item => item.wht_code === code)
      return rs ? `${rs.wht_code} - ${rs.wht_description}` : 'ไม่ระบุ'
    }
  },
  getBcElim(state) {
    return code => {
      const rs = state.bcElim.find(item => item.code === code)
      return rs ? `${rs.code} - ${rs.name}` : 'ไม่ระบุ'
    }
  }
}

const mutations = {
  setInit(state) {
    state.loadingPage = true
    state.company = []
    // state.companyDefault = null
    state.currency = []
    state.currencyDefault = 'THB'
    state.employee = []
    state.employeeAll = []
    state.employeeDefault = {
      bu_no: '',
      bu_name: '',
      fullname_th: '',
      employee_id: '',
      telephone: ''
    }
    state.cash = []
    state.taxRate = []
    state.catCode = []
    state.documentSpacialPath = []
    state.cashDefault = 'p'
    state.fileUploadMaxSizeKb = 0
    state.fileUploadMaxSize = 0
    state.overBudget = {
      message: null,
      isOver: true,
      show: false
    }
    state.advanceCostADV1 = []
    state.advanceCostADV2 = []
    state.advanceCostADV3 = []
    state.uom = []
    state.docWait = {
      memo: 0,
      pv: 0,
      ca: 0,
      cl: 0,
      pr: 0,
      po: 0,
      gr: 0,
      of: 0,
      rf: 0,
      procurement: 0,
      reimbursement: 0,
      preorder: 0
    }
    state.optionBudget = []
    state.optionBudgetSubledger = []
    state.optionFilterList.memo = []
    state.optionFilterList.reimburement = []
    state.optionFilterList.procurement = []
    state.optionFilterList.preorder = []
    state.btnResend = {
      disabled: false,
      loading: false,
      hide: true
    }

    state.bcVatProd = []
    state.bcWhtBus = []
    state.bcWhtProd = []
    state.bcElim = []
  },
  setLoadingPage(state, data) {
    state.loadingPage = data
  },
  setCompany(state, data) {
    state.company = data
  },
  setCompanyDefault(state, data) {
    // state.companyDefault = data
    state.companyDefault = state.company.find(item => {
      return item.comp_no == data.no
    })
  },
  setEmployeeDefault(state, data) {
    state.employeeDefault = data
  },
  setCurrency(state, data) {
    state.currency = data
  },
  setCash(state, data) {
    state.cash = data
  },
  setTaxRate(state, data) {
    state.taxRate = data
  },
  setCatCode(state, data) {
    state.catCode = data
  },
  setFileUploadMaxSize(state, data) {
    state.fileUploadMaxSizeKb = data.kb
    state.fileUploadMaxSize = data.mb
  },
  setEmployee(state, data) {
    state.employee = data
  },
  setDocumentSpacialPath(state, data) {
    state.documentSpacialPath = data
  },
  setOverBudget(state, data) {
    state.overBudget.message = data.message
    state.overBudget.isOver = data.isOver
    state.overBudget.show = data.show
  },
  resetOverBudget(state) {
    state.overBudget.message = null
    state.overBudget.isOver = true
    state.overBudget.show = false
  },
  setAdvanceCostADV1(state, data) {
    state.advanceCostADV1 = data
  },
  setAdvanceCostADV2(state, data) {
    state.advanceCostADV2 = data
  },
  setAdvanceCostADV3(state, data) {
    state.advanceCostADV3 = data
  },
  setUOM(state, data) {
    state.uom = data
  },
  setEmployeeAll(state, data) {
    state.employeeAll = data
  },
  setDocWait(state, data) {
    if (data.module == 'reimbursement') {
      state.docWait.pv = data.pv
      state.docWait.ca = data.ca
      state.docWait.cl = data.cl
      state.docWait.reimbursement = data.reimbursement
    } else if (data.module == 'procurement') {
      state.docWait.pr = data.pr
      state.docWait.po = data.po
      state.docWait.gr = data.gr
      state.docWait.procurement = data.procurement
    } else if (data.module == 'preorder') {
      state.docWait.of = data.of
      state.docWait.rf = data.rf
      state.docWait.preorder = data.preorder
    }
  },
  setDocWaitType(state, data) {
    state.docWait[data.type] = data.value
  },
  setOptionBudget(state, data) {
    state.optionBudget = data
  },
  setOptionBudgetSubledger(state, data) {
    state.optionBudgetSubledger = data
  },
  setOptionFilterList(state, data) {
    state.optionFilterList.memo = data
  },
  setReimburementOptionFilterList(state, data) {
    state.optionFilterList.reimburement = data
  },
  setProcurementOptionFilterList(state, data) {
    state.optionFilterList.procurement = data
  },
  setPreorderOptionFilterList(state, data) {
    state.optionFilterList.preorder = data
  },
  setBtnActiveFix(state, data) {
    state[data.type].loading = data.status
    state[data.type].disabled = data.status
  },
  setBtnHide(state, data) {
    state[data.type].hide = data.status
  },
  setOptionStatus(state, data) {
    state.optionStatusList[data.type] = data.data
  },
  setAnalysisCode(state, data) {
    state.analysisCode = data.data
  },
  setAnalysisCode1(state, data) {
    state.analysisCode1 = data
  },
  setAnalysisCode2(state, data) {
    state.analysisCode2 = data
  },
  setAnalysisCode9(state, data) {
    state.analysisCode9 = data
  },
  setAnalysisCode10(state, data) {
    state.analysisCode10 = data
  },
  setBcVatProd(state, data) {
    state.bcVatProd = data.data.length > 0 ? data.data : []
  },
  setBcWhtBus(state, data) {
    state.bcWhtBus = data.data.length > 0 ? data.data : []
  },
  setBcWhtProd(state, data) {
    state.bcWhtProd = data.data.length > 0 ? data.data : []
  },
  setBcElim(state, data) {
    state.bcElim = data.data.length > 0 ? data.data : []
  }
}

const actions = {
  setCompanyDefault({ commit }) {
    commit('setCompanyDefault', { no: this.state.auth.info.comp_no })
  },
  async loadCompany({ commit, state }) {
    if (state.company.length === 0) {
      await api.get('/admin/company/all?per_page=500').then(res => {
        if (res.code == 200) {
          commit('setCompany', res.data.data.map((v) => { v.comp_logo = v.comp_logo_url; return v }))
          commit('setCompanyDefault', { no: this.state.auth.info.comp_no })
        }
      })
    }
  },
  async loadCompanyDefault({ commit, state }) {
    if (state.company.length === 0) {
      commit('setCompanyDefault', { no: this.state.auth.info.comp_no })
    }
  },
  async loadCompanyToken({ commit, state }, compNo) {
    if (state.company.length === 0) {
      await api.get('/admin/company/all?per_page=500').then(res => {
        if (res.code == 200) {
          // commit('setCompany', res.data.data)
          commit('setCompany', res.data.data.map((v) => { v.comp_logo = v.comp_logo_url; return v }))
          // commit('setCompanyDefault', { no: compNo })
        }
      })
    }
  },
  async loadCurrency({ commit, state }) {
    if (state.currency.length === 0) {
      await api.get('/admin/masterData/getCurrencyAll').then(res => {
        if (res.code == 200) {
          commit('setCurrency', res.data)
        }
      })
    }
  },
  async loadCash({ commit, state }) {
    if (state.cash.length === 0) {
      await api.get('/admin/masterData/getPettyCashAll').then(res => {
        if (res.code == 200) {
          commit('setCash', res.data)
        }
      })
    }
  },
  async loadCashByCompany({ commit, state }, payload) {
    await api.get(`/admin/masterData/getPettyCashAll?compCode=${payload.compCode}`).then(res => {
      if (res.code == 200) {
        commit('setCash', res.data)
      }
    })
  },
  async loadTaxRate({ commit, state }) {
    if (state.taxRate.length === 0) {
      await api.get('/admin/vatTax/all?per_page=500').then(res => {
        if (res.code == 200) {
          commit('setTaxRate', res.data.data)
        }
      })
    }
  },
  async loadCatCode({ commit, state }) {
    if (state.catCode.length === 0) {
      await api.get('/admin/catCode/all?per_page=500').then(res => {
        if (res.code == 200) {
          commit('setCatCode', res.data.data)
        }
      })
    }
  },
  async loadFileUploadMaxSize({ commit, state }) {
    if (state.fileUploadMaxSize === 0) {
      await api.get('/file/file/info').then(res => {
        if (res.code == 200) {
          commit('setFileUploadMaxSize', {
            kb: res.data.maxSize,
            mb: res.data.maxSizeMb
          })
        }
      })
    }
  },
  async loadEmployee({ commit, state }) {
    // console.log('state: ', this.state.auth.info)
    if (state.employee.length === 0) {
      await api
        .get(
          // '/admin/employee/all?per_page=2000&filter=user_profile.employee_id,user_profile.fullname_th'
          // `/admin/employee/getCanDelegateByEmployeeId/${state.employeeDefault}?filter=employee_id,fullname_th`
          `/admin/employee/getCanDelegateByEmployeeId/${this.state.auth.info.employeeId}?fields=employee_id,fullname_th,bu_no,bu_name,telephone`
        )
        .then(res => {
          commit('setEmployeeDefault', this.state.auth.info.employeeId)
          commit('setEmployee', res.data.data)
        })
    }
  },
  async loadEmployeeAll({ commit, state }) {
    // console.log('state: ', this.state.auth.info)
    if (state.employeeAll.length === 0) {
      await api
        .get(
          // https://wf-api.nationgroup.com/api/admin/employee/all
          '/admin/employee/all?per_page=2000&fields=user_profile.employee_id,fullname_th,fullname_en,username,user_profile.fullname_th,bu_no,bu_name,telephone'
          // `/admin/employee/getCanDelegateByEmployeeId/${state.employeeDefault}?filter=employee_id,fullname_th`
          // `/admin/employee/getCanDelegateByEmployeeId/${this.state.auth.info.employeeId}?filter=employee_id,fullname_th`
        )
        .then(res => {
          // commit('setEmployeeDefault', this.state.auth.info.employeeId)
          commit('setEmployeeAll', res.data.data)
        })
    }
  },
  async loadDocumentSpacialPath({ commit }, payload) {
    // console.log('load special path')
    await api
      .get(`/admin/documentPath/getSpecialPathAll?comp_no=${payload.compNo}`)
      .then(res => {
        commit('setDocumentSpacialPath', res.data.data)
      })
  },
  async loadAdvanceCostADV1({ commit, state }) {
    if (state.advanceCostADV1.length === 0) {
      await api
        .get('/admin/advcost/getAll?adv_cost=ADV1&per_page=500')
        .then(res => {
          if (res.code == 200) {
            commit('setAdvanceCostADV1', res.data.data)
          }
        })
    }
  },
  async loadAdvanceCostADV2({ commit, state }) {
    if (state.advanceCostADV2.length === 0) {
      await api
        .get('/admin/advcost/getAll?adv_cost=ADV2&per_page=500')
        .then(res => {
          if (res.code == 200) {
            commit('setAdvanceCostADV2', res.data.data)
          }
        })
    }
  },
  async loadAdvanceCostADV3({ commit, state }) {
    if (state.advanceCostADV3.length === 0) {
      await api
        .get('/admin/advcost/getAll?adv_cost=ADV3&per_page=500')
        .then(res => {
          if (res.code == 200) {
            commit('setAdvanceCostADV3', res.data.data)
          }
        })
    }
  },
  async loadUOM({ commit, state }) {
    if (state.uom.length === 0) {
      await api.get('/admin/uom/all?per_page=500').then(res => {
        if (res.code == 200) {
          commit('setUOM', res.data.data)
        }
      })
    }
  },
  async loadCountMyDocReimbursement({ commit }, employeeId) {
    await api
      .get(`/reimbursement/activity/countDocWait/${employeeId}`)
      .then(async res => {
        if (res.code == 200) {
          res.data.module = 'reimbursement'
          commit('setDocWait', res.data)
        }
      })
  },
  async loadCountMyDocProcurement({ commit }, employeeId) {
    await api
      .get(`/procurement/activity/countDocWait/${employeeId}`)
      .then(async res => {
        if (res.code == 200) {
          res.data.module = 'procurement'
          commit('setDocWait', res.data)
        }
      })
  },
  async loadCountMyDocPreorder({ commit }, employeeId) {
    await api
      .get(`/preorder/activity/countDocWait/${employeeId}`)
      .then(async res => {
        if (res.code == 200) {
          res.data.module = 'preorder'
          commit('setDocWait', res.data)
        }
      })
  },
  async loadOptionBudget({ commit }) {
    await api.get('/admin/budget/allOption').then(res => {
      commit('setOptionBudget', res.data)
    })
  },
  async loadOptionBudgetSubledger({ commit }) {
    await api.get('admin/budget/subLedgerAllOption').then(res => {
      commit('setOptionBudgetSubledger', res.data)
    })
  },
  async loadOptionFilterList({ commit }) {
    await api.get('memo/memo/getFilterOption').then(res => {
      commit('setOptionFilterList', res.data)
    })
    await api.get('reimbursement/activity/getFilterOption').then(res => {
      commit('setReimburementOptionFilterList', res.data)
    })
    await api.get('procurement/activity/getFilterOption').then(res => {
      commit('setProcurementOptionFilterList', res.data)
    })
    await api.get('preorder/activity/getFilterOption').then(res => {
      commit('setPreorderOptionFilterList', res.data)
    })
  },
  async loadOptionStatus({ commit, state }, data) {
    if (state.optionStatusList[data.type].length === 0) {
      await api
        .get(`admin/wfStatus/getStatusCodeOption/${data.type}`)
        .then(res => {
          commit('setOptionStatus', {
            data: res.data,
            type: data.type
          })
        })
    }
  },
  async loadOptionAnalysisCode({ commit, state }) {
    if (state.analysisCode.length === 0) {
      await api.get('jde/analysisCode/data').then(res => {
        // console.log('res: ', res.data.analysisCode)
        commit('setAnalysisCode', {
          data: res.data.analysisCode
        })

        if (res.data.analysisCode) {
          var analy1 = []
          var analy2 = []
          var analy9 = []
          var analy10 = []
          for (const i in res.data.analysisCode) {
            switch (res.data.analysisCode[i].dimension_id) {
              case '06':
                analy1.push(res.data.analysisCode[i])
                break
              case '07':
                analy2.push(res.data.analysisCode[i])
                break
              case '09':
                analy9.push(res.data.analysisCode[i])
                break
              case '10':
                analy10.push(res.data.analysisCode[i])
                break
            }
          }
          commit('setAnalysisCode1', analy1)
          commit('setAnalysisCode2', analy2)
          commit('setAnalysisCode9', analy9)
          commit('setAnalysisCode10', analy10)
        }
      })
    }
  },
  async loadBc({ commit, state }) {
    if (
      state.bcVatProd.length === 0 ||
      state.bcWhtBus.length === 0 ||
      state.bcWhtProd.length === 0 ||
      state.bcElim.length === 0
    ) {
      await api
        .get('admin/bc/getBcVatProd?per_page=1000')
        .then(res => commit('setBcVatProd', { data: res.data.data }))
      await api
        .get('admin/bc/getBcWhtBus?per_page=1000')
        .then(res => commit('setBcWhtBus', { data: res.data.data }))
      await api
        .get('admin/bc/getBcWhtProd?per_page=1000')
        .then(res => commit('setBcWhtProd', { data: res.data.data }))
      await api
        .get('admin/bc/getBcElim?per_page=1000')
        .then(res => commit('setBcElim', { data: res.data.data }))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
